import * as fp from '../vendor/fingerpose/fingerpose';

const DpcThumbsUp = new fp.GestureDescription('dpc_thumbs_up');
DpcThumbsUp.addCurl(fp.Finger.Thumb, fp.FingerCurl.NoCurl, 1.0);
DpcThumbsUp.addDirection(fp.Finger.Thumb, fp.FingerDirection.VerticalUp, 1.0);
DpcThumbsUp.addDirection(
  fp.Finger.Thumb,
  fp.FingerDirection.DiagonalUpLeft,
  0.9
);
DpcThumbsUp.addDirection(
  fp.Finger.Thumb,
  fp.FingerDirection.DiagonalUpRight,
  0.9
);
for (const finger of [
  fp.Finger.Index,
  fp.Finger.Middle,
  fp.Finger.Ring,
  fp.Finger.Pinky,
]) {
  DpcThumbsUp.addCurl(finger, fp.FingerCurl.FullCurl, 1.0);
  DpcThumbsUp.addCurl(finger, fp.FingerCurl.HalfCurl, 0.9);
}

export { DpcThumbsUp };
